<template>
  <v-dialog 
    id="nav-help-dialog"
    v-model="isOpen"
    v-show="isLoggedIn"
    persistent
    width="300px"
  > 
    <template v-slot:activator="{ on }">
      <v-btn 
        id="nav-help-button"
        v-on="on"
        text 
        fab  
        small 
        rounded 
      >
        <v-icon dark>help</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2" 
        primary-title
      >
        About
      </v-card-title>
      <v-card-text 
        v-html="this.aboutText" 
      />

      <HelpDialogTooltip 
        :isLoggedIn="this.isLoggedIn"
        :isAdmin="this.isAdmin"
        :tokenString="this.tokenString"
      />

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn 
          @click="isOpen = false"
          color="primary"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>                    
  </v-dialog>
</template>

<script>
import HelpDialogTooltip from './HelpDialogTooltip'

export default {
  name: "HelpDialog",
  components: {
    HelpDialogTooltip
  },
  props: [
    "isLoggedIn",
    "isAdmin",
    "tokenString",
    "aboutText",
  ],
  data() {
    return {
      isOpen: false
    }
  }
}
</script>

<style scoped>
#nav-help-button {
  color: white;
}
#nav-help-dialog {
  width: 300px;
}
</style>